<template>
  <div id="dashboard-analytics">
    <div class="row">
      <h3 class="col-8 p-2" style="color: #5E5873;">
        <b>Invoice Listing</b>
      </h3>
      <!-- <div> -->

      <!-- <b-form-group  label="Select Company" label-for="Select Company" style="width:100px"> -->
      <select name="status" id="status" v-model="companyName" class="form-control col-3" style="margin-top:30px;margin-left:80px;font-family: Montserrat;
font-style: normal;
font-weight: 600;
font-size: 14px;
line-height: 21px;">
        <option v-for="company in companyNames" :value="company.companyName">
          {{ company.companyName }}
        </option>
      </select>

      <!-- </b-form-group> -->
      <!-- </div> -->
    </div>
    <div class="row" v-if="invoiceListFlag">
      <b-button @click="viewInvoiceData()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
        style="margin-left:20px;">
        Invoice List
      </b-button>
      <b-button @click="viewBulkData()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-dark"
        style="margin-left:20px">
        Bulk Invoice Data
      </b-button>
    </div>

    <div class="row" v-else>
      <b-button @click="viewInvoiceData()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-dark"
        style="margin-left:20px;">
        Invoice List
      </b-button>
      <b-button @click="viewBulkData()" v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="primary"
        style="margin-left:20px">
        Bulk Invoice Data
      </b-button>
    </div>
    <br />

    <!-- <div class="row" style="margin-left:-5px">
  <b-form-group class="col-3" label="Select Company" label-for="Select Company" style="width:100px">
    <select name="status" id="status" v-model="companyName" class="form-control" >
      <option  selected value="">Select Company</option>
      <option  selected value="JIOMART">JIOMART</option>
      <option  selected value="YARAELECTRONICS">YARAELECTRONICS</option>
      <option  selected value="RETAILPS">RETAILPS</option>
      <option  selected value="PALODD">PALODD</option>
      <option  selected value="UNIPATCH">UNIPATCH</option>

    </select>

  </b-form-group>
  <b-button
    style="height: 40px; width: 158px; margin-top: 20px;margin-left: 18px;"
    @click="getInvoices()"
    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
    variant="primary"
  >
    Submit
  </b-button>
  </div> -->

    <div class="container testimonial-group" style="margin-top:24px" v-if="invoiceListFlag">
      <div class="row text-center">
        <vx-card class="card col" style="height: fit-content;padding: 0px;" v-on:click="changeSelection(1)"
          v-bind:class="{ changecolor: activeTab === 1 }">
          <div class="container row" style="padding: 0px;
    margin-right: 0px;
    margin-left: 0px;" v-bind:class="{ changecolor: activeTab === 1 }">
            <div class="col-6">
              <span class="supplier-count" v-bind:class="{ changecolor: activeTab === 1 }">
                <b>{{ submittedInvoiceDetails }}</b>
              </span>
              <br />
              <span style="font-family: Montserrat;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 21px;">
                Submitted
              </span>
            </div>
            <div class="col-6" style="margin: auto;padding: 0px;">
              <img style="margin: auto 0px auto auto;" src="../../assets/icons/invoiceSubmitted.png" />
            </div>
          </div>
        </vx-card>

        <vx-card class="card col" style="height: fit-content;padding: 0px;" v-on:click="changeSelection(2)"
          v-bind:class="{ changecolorOne: activeTab === 2 }">
          <div class="container row" style="padding: 0px;
    margin-right: 0px;
    margin-left: 0px;" v-bind:class="{ changecolorOne: activeTab === 2 }">
            <div class="col-6">
              <span class="supplier-count" v-bind:class="{ changecolorOne: activeTab === 2 }">
                <b>{{ approvedInvoiceDetails }}</b>
              </span>
              <br />
              <span style="font-family: Montserrat;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 21px;">
                Approved
              </span>
            </div>
            <div class="col-6" style="margin: auto;padding: 0px;">
              <img style="margin: auto 0px auto auto;" src="../../assets/icons/invoiceApproved.png" />
            </div>
          </div>
        </vx-card>

        <vx-card class="card col" style="height: fit-content;padding: 0px;" v-on:click="changeSelection(3)"
          v-bind:class="{ changecolorTwo: activeTab === 3 }">
          <div class="container row" style="padding: 0px;
    margin-right: 0px;
    margin-left: 0px;" v-bind:class="{ changecolorTwo: activeTab === 3 }">
            <div class="col-6">
              <span class="supplier-count" v-bind:class="{ changecolorTwo: activeTab === 3 }">
                <b>{{ awaitingInvoiceDetails }}</b>
              </span>
              <br />
              <span style="font-family: Montserrat;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 21px;">
                Awaiting Approval
              </span>
            </div>
            <div class="col-6" style="margin: auto;padding: 0px;">
              <img style="margin: auto 0px auto auto;" src="../../assets/icons/invoiceAwaitingApp.png" />
            </div>
          </div>
        </vx-card>
        <vx-card class="card col" style="height: fit-content;padding: 0px;" v-on:click="changeSelection(4)"
          v-bind:class="{ changecolorThree: activeTab === 4 }">
          <div class="container row" style="padding: 0px;
    margin-right: 0px;
    margin-left: 0px;" v-bind:class="{ changecolorThree: activeTab === 4 }">
            <div class="col-6">
              <span class="supplier-count" v-bind:class="{ changecolorThree: activeTab === 4 }">
                <b>{{ ignoredInvoiceDetails }}</b>
              </span>
              <br />
              <span style="font-family: Montserrat;
font-style: normal;
font-weight: normal;
font-size: 14px;
line-height: 21px;">
                Ignored
              </span>
            </div>
            <div class="col-6" style="margin: auto;padding: 0px;">
              <img style="margin: auto 0px auto auto;" src="../../assets/icons/invoiceIgnored.png" />
            </div>
          </div>
        </vx-card>
        <vx-card class="card col" style="height: fit-content;padding: 0px;" v-on:click="changeSelection(5)"
          v-bind:class="{ changecolorFour: activeTab === 5 }">
          <div class="container row" style="padding: 0px;
    margin-right: 0px;
    margin-left: 0px;" v-bind:class="{ changecolorFour: activeTab === 5 }">
            <div class="col-6">
              <span class="supplier-count" v-bind:class="{ changecolorFour: activeTab === 5 }">
                <b>{{ closedInvoiceDetails }}</b>
              </span>
              <br />
              <span style="font-family: Montserrat;
              font-style: normal;
              font-weight: normal;
              font-size: 14px;
              line-height: 21px;">
                Rejected
              </span>
            </div>
            <div class="col-6" style="margin: auto;padding: 0px;">
              <img style="margin: auto 0px auto auto;" src="../../assets/icons/invoiceRejected.png" />
            </div>
          </div>
        </vx-card>
      </div>
    </div>

    <vx-card class="card" style="height: fit-content;margin-top : 28px;width:100%;padding:16px" v-if="invoiceListFlag">
      <div class="row">
        <b-form-group class="col" label="Date Range" label-for="Date Range">
          <flat-pickr v-model="rangeDate" class="form-control" :config="{ mode: 'range' }" />
        </b-form-group>

        <b-form-group class="col" label="Invoice Number" label-for="invoiceNumber">
          <b-form-input id="invoiceNumber" v-model="invoiceNumber" placeholder="Invoice Number" />
        </b-form-group>
        <b-form-group class="col" label="Supplier Name" label-for="supplierName">
          <b-form-input v-model="supplierName" id="supplierName" placeholder="Supplier Name" />
        </b-form-group>
        <b-form-group class="col" label="Merchant" label-for="merchantName">
          <b-form-input v-model="merchantName" id="merchantName" placeholder="Merchant" />
        </b-form-group>
      </div>
      <template>
        <b-row style="margin-top : 30px">
          <b-col cols="12">
            <b-table ref="selectableTable" selectable striped hover responsive :per-page="perPage"
              :current-page="currentPage" :items="items" :fields="fields" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
              :filter-included-fields="filterOn" @row-selected="onRowSelected">
              <template #cell(createdAt)="data">
                <span style="color:#6E6B7B;white-space: nowrap;"><b>{{ data.value | moment("DD MMM, YYYY") }}</b></span>
              </template>
              <template #cell(invoiceAmount)="data">
                <span>{{ data.value.toLocaleString() }}</span>
              </template>

              <template #cell(invoiceId)="data">
                <span style="color:#4328AE;"><b>{{ data.value }}</b></span>
              </template>

              <template #cell(invoiceDate)="data">
                <span style="color:#6E6B7B;white-space: nowrap;"><b>{{ data.value | moment("DD MMM, YYYY") }}</b></span>
              </template>
            </b-table>
          </b-col>
          <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
            <!-- page length -->
            <b-form-group label="Per Page" label-cols="6" label-align="left" label-size="sm" label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1">
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination style="margin:auto" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                align="center" size="sm" class="my-0" />
            </div>
          </b-card-body>
        </b-row>
      </template>
    </vx-card>

    <vx-card class="card" style="height: fit-content;margin-top : 28px;width:100%;padding:16px" v-else>
      <div class="vx-row">
        <datepicker class="vx-col w-full lg:w-1/4" placeholder="Select From Date" v-model="startDate"
          style="margin-top: 10px;"></datepicker>
        <datepicker class="vx-col w-full lg:w-1/4" placeholder="Select To Date" v-model="endDate"
          style="margin-top: 10px;">
        </datepicker>

        <!-- <vs-select class="w-full vx-col w-full lg:w-1/4" style="margin-top: 10px;" v-model="stageSelected">
        <vs-select-item
          :key="index"
          :value="item.value"
          :text="item.text"
          v-for="(item,index) in kycStage"

        />
      </vs-select> -->

        <b-button style="height: 40px;
                  width: 158px;
                  margin-top: 11px;" @click="submitInvoice()" v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary">
          Submit
        </b-button>
      </div>
      <br />
      <div class="row">
        <b-form-group class="col" label="Invoice Date" label-for="Date Range">
          <flat-pickr v-model="rangeDateB" class="form-control" :config="{ mode: 'range' }" />
        </b-form-group>

        <b-form-group class="col" label="Invoice Number" label-for="invoiceNumber">
          <b-form-input v-model="invoiceNumberB" id="supplierName" placeholder="Invoice Number" />
        </b-form-group>
        <b-form-group class="col" label="Supplier Name" label-for="supplierName">
          <b-form-input v-model="supplierNameB" id="supplierName" placeholder="Supplier Name" />
        </b-form-group>
        <b-form-group class="col" label="Merchant" label-for="merchantName">
          <b-form-input v-model="merchantNameB" id="merchantName" placeholder="Merchant" />
        </b-form-group>
        <b-form-group class="col" label="Clear All Filters" label-for="merchantName">
          <b-button @click="clearFilter()" v-ripple.400="'rgba(30, 30, 30, 0.15)'" variant="outline-primary"
            style="border: 1px solid #7367F0;">
            Clear Filter
          </b-button>
        </b-form-group>
      </div>
      <template>
        <b-row style="margin-top : 30px">
          <b-col cols="12">
            <b-table ref="selectableTable" selectable striped hover responsive :per-page="perPage"
              :current-page="currentPage" :items="bulkitems" :fields="fieldsNew" :sort-by.sync="sortBy"
              :sort-desc.sync="sortDesc" :sort-direction="sortDirection" :filter="filter"
              :filter-included-fields="filterOn" @row-selected="onRowSelectedNew">
              <template #cell(createdAt)="data">
                <span style="color:#6E6B7B;white-space: nowrap;"><b>{{ data.value | moment("DD MMM, YYYY") }}</b></span>
              </template>
              <template #cell(invoiceAmount)="data">
                <span>{{ data.value.toLocaleString() }}</span>
              </template>

              <template #cell(invoiceId)="data">
                <span style="color:#4328AE;"><b>{{ data.value }}</b></span>
              </template>

              <template #cell(invoiceDate)="data">
                <span style="color:#6E6B7B;white-space: nowrap;"><b>{{ data.value | moment("DD MMM, YYYY") }}</b></span>
              </template>

              <template #cell(invoiceDueDate)="data">
                <span style="color:#6E6B7B;white-space: nowrap;"><b>{{ data.value | moment("DD MMM, YYYY") }}</b></span>
              </template>
            </b-table>
          </b-col>
          <b-card-body class="d-flex justify-content-between flex-wrap pt-0">
            <!-- page length -->
            <b-form-group label="Per Page" label-cols="6" label-align="left" label-size="sm" label-for="sortBySelect"
              class="text-nowrap mb-md-0 mr-1">
              <b-form-select id="perPageSelect" v-model="perPage" size="sm" inline :options="pageOptions" />
            </b-form-group>

            <!-- pagination -->
            <div>
              <b-pagination style="margin:auto" v-model="currentPage" :total-rows="totalRows" :per-page="perPage"
                align="center" size="sm" class="my-0" />
            </div>
          </b-card-body>
        </b-row>
      </template>
    </vx-card>
  </div>
</template>

<script>
import axios from "axios";
import flatPickr from "vue-flatpickr-component";
import Datepicker from "vuejs-datepicker";
export default {
  data() {
    return {
      rangeDate: "",
      perPage: 30,
      pageOptions: [3, 5, 10],
      totalRows: 1,
      currentPage: 1,
      sortBy: "",
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      filterOn: [],
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      },
      fieldsNew: [
        {
          key: "purchaseOrderNumber",
          label: "INVOICE NO"
        },
        {
          key: "createdAt",
          label: "SUBMITTED ON"
        },
        { key: "invoiceDate", label: "INVOICE DATE", sortable: true },
        { key: "invoiceDueDate", label: "DUE DATE", sortable: true },
        {
          key: "supplierName",
          label: "SUPPLIER",
          sortable: true
        },
        { key: "invoiceAmount", label: "INVOICE AMOUNT", sortable: true },
        { key: "borrowerName", label: "MERCHANT", sortable: true }
      ],
      fields: [
        {
          key: "purchaseOrderNumber",
          label: "INVOICE NO"
        },
        {
          key: "createdAt",
          label: "SUBMITTED ON"
        },
        { key: "invoiceDate", label: "INVOICE DATE", sortable: true },
        {
          key: "supplierDetails.name",
          label: "SUPPLIER",
          sortable: true
        },
        { key: "invoiceAmount", label: "INVOICE AMOUNT", sortable: true },
        { key: "borrowerName", label: "MERCHANT", sortable: true }
      ],
      invoiceNumber: "",
      invoiceNumberB: "",
      supplierNameB: "",
      merchantNameB: "",
      rangeDateB: "",
      supplierName: "",
      merchantName: "",
      tabSelected: 1,
      companyName: "",

      selected: [],
      awaitingInvoiceDetails: 0,
      closedInvoiceDetails: 0,
      activeInvoiceDetails: [],
      submittedInvoiceDetails: 0,
      approvedInvoiceDetails: 0,
      ignoredInvoiceDetails: 0,
      invoiceDetails: [],
      activeTab: 1,
      statusSend: "Submitted",
      invoiceId: "",
      invoiceListFlag: true,
      startDate: new Date(),
      endDate: new Date(),
      companyNames: [],
      invoiceDetailsSubmitted: [],
      invoiceDetailsApproved: [],
      invoiceDetailsAwaiting: [],
      invoiceDetailsIgnored: [],
      invoiceDetailsRejected: []
    };
  },
  components: { flatPickr, Datepicker },
  created() {
    this.statusSend = "Submitted";
    this.companyName = this.$route.query.companyName;
    this.getInvoices();
    this.getCompanies();
  },
  methods: {
    setAppClasses(classesStr) {
      this.vueAppClasses.push(classesStr);
    },
    clearFilter() {
      this.invoiceNumberB = "";
      this.supplierNameB = "";
      this.merchantNameB = "";
      this.rangeDateB = "";
    },
    viewBulkData() {
      this.invoiceListFlag = false;
      this.invoiceDetails = [];
    },
    viewInvoiceData() {
      this.invoiceListFlag = true;
      this.getInvoices();
    },
    logOut() {
      this.$router.push({
        path: "/",
        query: {}
      });
    },
    onRowSelected(items) {
      this.selected = items;
      this.$router.push({
        path: "/InvoiceDetails",
        query: {
          purchaseOrderNumber: items[0].invoiceId,
          activeTab: this.activeTab,
          companyName: this.companyName
        }
      });
      this.$refs.selectableTable.clearSelected();
    },

    onRowSelectedNew(items) {
      this.selected = items;
      this.$router.push({
        path: "/InvoiceDetails",
        query: {
          purchaseOrderNumber: items[0].invoiceId,
          activeTab: 3,
          companyName: this.companyName
        }
      });
      this.$refs.selectableTable.clearSelected();
    },
    changeSelection: function (position) {
      this.activeTab = position;
      if (this.activeTab === 1) {
        this.statusSend = "Submitted";
        // this.getInvoices();
        this.invoiceDetails = this.invoiceDetailsSubmitted;
      } else if (this.activeTab === 2) {
        this.statusSend = "Approved";
        this.invoiceDetails = this.invoiceDetailsApproved;
        // this.getInvoices();
      } else if (this.activeTab === 3) {
        this.statusSend = "Awaiting Approval";
        this.invoiceDetails = this.invoiceDetailsAwaiting;
        // this.getInvoices();
      } else if (this.activeTab === 4) {
        this.statusSend = "Ignored";
        this.invoiceDetails = this.invoiceDetailsIgnored;
        // this.getInvoices();
      } else if (this.activeTab === 5) {
        this.statusSend = "Reject";
        this.invoiceDetails = this.invoiceDetailsRejected;
        // this.getInvoices();
      }
    },

    getInvoicesSubmitted() {
      this.$store.commit("routeChange", "start");
      var self = this;
      var url =
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?status=Submitted&companyName=" +
        self.companyName;
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);

          self.invoiceDetailsSubmitted =
            JSONData.invoiceDetails.SUBMITTED.invoiceDetailsResp;
          self.submittedInvoiceDetails =
            JSONData.invoiceDetails.SUBMITTED.count;
          if (self.activeTab === 1) {
            if (self.submittedInvoiceDetails === 0) {
              self.invoiceDetails = [];
            } else {
              self.invoiceDetails = self.invoiceDetailsSubmitted;
            }
          }
          // if (self.activeTab === 1) {
          //
          // } else if (self.activeTab === 2) {
          //   self.invoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // } else if (self.activeTab === 3) {
          //   self.invoiceDetails = JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // } else if (self.activeTab === 4) {
          //   self.invoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // } else if (self.activeTab === 5) {
          //   self.invoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // }
          // self.awaitingInvoiceDetails =
          //   JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // self.closedInvoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // self.activeInvoiceDetails = JSONData.invoiceDetails.LOAN_ACTIVE.invoiceDetailsResp;
          //
          // self.approvedInvoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // self.ignoredInvoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // self.totalRows = self.invoiceDetails.length;

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.invoiceDetails = [];
          self.invoiceDetailsSubmitted = [];
          self.submittedInvoiceDetails = 0;
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },

    getInvoicesApproved() {
      this.$store.commit("routeChange", "start");
      var self = this;
      var url =
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?status=Approved&companyName=" +
        self.companyName;
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);

          self.invoiceDetailsApproved =
            JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          self.approvedInvoiceDetails = JSONData.invoiceDetails.APPROVED.count;
          // if (self.activeTab === 1) {
          //
          // } else if (self.activeTab === 2) {
          //   self.invoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // } else if (self.activeTab === 3) {
          //   self.invoiceDetails = JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // } else if (self.activeTab === 4) {
          //   self.invoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // } else if (self.activeTab === 5) {
          //   self.invoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // }
          // self.awaitingInvoiceDetails =
          //   JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // self.closedInvoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // self.activeInvoiceDetails = JSONData.invoiceDetails.LOAN_ACTIVE.invoiceDetailsResp;
          //
          // self.approvedInvoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // self.ignoredInvoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // self.totalRows = self.invoiceDetails.length;

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.invoiceDetailsApproved = [];
          self.approvedInvoiceDetails = 0;
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },

    getInvoicesAwaiting() {
      this.$store.commit("routeChange", "start");
      var self = this;
      var status = "Awaiting Approval";
      var url =
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?status=" +
        status +
        "&companyName=" +
        self.companyName;
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);

          self.invoiceDetailsAwaiting =
            JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          self.awaitingInvoiceDetails =
            JSONData.invoiceDetails.AWAITING_APPROVAL.count;
          // if (self.activeTab === 1) {
          //
          // } else if (self.activeTab === 2) {
          //   self.invoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // } else if (self.activeTab === 3) {
          //   self.invoiceDetails = JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // } else if (self.activeTab === 4) {
          //   self.invoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // } else if (self.activeTab === 5) {
          //   self.invoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // }
          // self.awaitingInvoiceDetails =
          //   JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // self.closedInvoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // self.activeInvoiceDetails = JSONData.invoiceDetails.LOAN_ACTIVE.invoiceDetailsResp;
          //
          // self.approvedInvoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // self.ignoredInvoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // self.totalRows = self.invoiceDetails.length;

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.invoiceDetailsAwaiting = [];
          self.awaitingInvoiceDetails = 0;
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },

    getInvoicesIgnored() {
      this.$store.commit("routeChange", "start");
      var self = this;

      var url =
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?status=Ignored&companyName=" +
        self.companyName;
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);

          self.invoiceDetailsIgnored =
            JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          self.ignoredInvoiceDetails = JSONData.invoiceDetails.IGNORED.count;
          // if (self.activeTab === 1) {
          //
          // } else if (self.activeTab === 2) {
          //   self.invoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // } else if (self.activeTab === 3) {
          //   self.invoiceDetails = JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // } else if (self.activeTab === 4) {
          //   self.invoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // } else if (self.activeTab === 5) {
          //   self.invoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // }
          // self.awaitingInvoiceDetails =
          //   JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // self.closedInvoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // self.activeInvoiceDetails = JSONData.invoiceDetails.LOAN_ACTIVE.invoiceDetailsResp;
          //
          // self.approvedInvoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // self.ignoredInvoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // self.totalRows = self.invoiceDetails.length;

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.invoiceDetailsIgnored = [];
          self.ignoredInvoiceDetails = 0;
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },

    getInvoicesRejected() {
      this.$store.commit("routeChange", "start");
      var self = this;

      var url =
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?status=Reject&companyName=" +
        self.companyName;
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);

          self.invoiceDetailsRejected =
            JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          self.closedInvoiceDetails = JSONData.invoiceDetails.REJECT.count;
          // if (self.activeTab === 1) {
          //
          // } else if (self.activeTab === 2) {
          //   self.invoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // } else if (self.activeTab === 3) {
          //   self.invoiceDetails = JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // } else if (self.activeTab === 4) {
          //   self.invoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // } else if (self.activeTab === 5) {
          //   self.invoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // }
          // self.awaitingInvoiceDetails =
          //   JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          // self.closedInvoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          // self.activeInvoiceDetails = JSONData.invoiceDetails.LOAN_ACTIVE.invoiceDetailsResp;
          //
          // self.approvedInvoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          // self.ignoredInvoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          // self.totalRows = self.invoiceDetails.length;

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          self.invoiceDetailsRejected = [];
          self.closedInvoiceDetails = 0;
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },

    getInvoices() {
      // this.$store.commit("routeChange", "start");
      // var self = this;
      // var url =
      //   "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?status=" + self.statusSend+"&companyName="+self.companyName;;
      // axios
      //   .get(url)
      //   .then(function(response) {
      //     // handle success
      //
      //     const JSONData = response.data;
      //     console.log("this is the data", response.data);
      //
      //
      //
      //     if (self.activeTab === 1) {
      //       self.invoiceDetails = JSONData.invoiceDetails.SUBMITTED.invoiceDetailsResp;
      //     } else if (self.activeTab === 2) {
      //       self.invoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
      //     } else if (self.activeTab === 3) {
      //       self.invoiceDetails = JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
      //     } else if (self.activeTab === 4) {
      //       self.invoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
      //     } else if (self.activeTab === 5) {
      //       self.invoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
      //     }
      //     self.awaitingInvoiceDetails =
      //       JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
      //     self.closedInvoiceDetails = JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
      //     self.activeInvoiceDetails = JSONData.invoiceDetails.LOAN_ACTIVE.invoiceDetailsResp;
      //     self.submittedInvoiceDetails = JSONData.invoiceDetails.SUBMITTED.invoiceDetailsResp;
      //     self.approvedInvoiceDetails = JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
      //     self.ignoredInvoiceDetails = JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
      //     self.totalRows = self.invoiceDetails.length;
      //
      //     self.$store.commit("routeChange", "end");
      //   })
      //   .catch(function(error) {
      //     // handle error
      //     console.log("display  ==" + error);
      //     self.$store.commit("routeChange", "end");
      //   })
      //   .finally(function() {
      //     self.$store.commit("routeChange", "end");
      //
      //   });

      this.getInvoicesSubmitted();
      this.getInvoicesApproved();
      this.getInvoicesAwaiting();
      this.getInvoicesIgnored();
      this.getInvoicesRejected();
    },

    getCompanies() {
      this.$store.commit("routeChange", "start");
      var self = this;
      var url =
        "https://uatgateway.supermoney.in/mintLoan/mintloan/getAnchorList";
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;

          self.companyNames = JSONData;
          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");

          // always executed
        });
    },

    getInvoicesClicked() {
      this.$store.commit("routeChange", "start");
      var self = this;
      var url =
        "https://uatgateway.supermoney.in/invoice-finance-services/invoice-services/finance/invoices/get?" +
        "&companyName=" +
        self.companyName;
      axios
        .get(url)
        .then(function (response) {
          // handle success

          const JSONData = response.data;
          console.log("this is the data", response.data);
          if (self.activeTab === 1) {
            self.invoiceDetails =
              JSONData.invoiceDetails.SUBMITTED.invoiceDetailsResp;
          } else if (self.activeTab === 2) {
            self.invoiceDetails =
              JSONData.invoiceDetails.APPROVED.invoiceDetailsResp;
          } else if (self.activeTab === 3) {
            self.invoiceDetails =
              JSONData.invoiceDetails.AWAITING_APPROVAL.invoiceDetailsResp;
          } else if (self.activeTab === 4) {
            self.invoiceDetails =
              JSONData.invoiceDetails.IGNORED.invoiceDetailsResp;
          } else if (self.activeTab === 5) {
            self.invoiceDetails =
              JSONData.invoiceDetails.REJECT.invoiceDetailsResp;
          }

          self.$store.commit("routeChange", "end");
        })
        .catch(function (error) {
          // handle error
          console.log("display  ==" + error);
          self.$store.commit("routeChange", "end");
          self.invoiceDetails = [];
        })
        .finally(function () {
          self.$store.commit("routeChange", "end");
          self.invoiceDetails = [];
          // always executed
        });
    },
    submitInvoice() {
      this.$store.commit("routeChange", "start");
      var timestamp = Math.round(+new Date() / 1000);
      var userip = this.$store.getters.ipAddress;
      var data = {
        from_date: this.startDate,
        to_date: this.endDate
      };
      var msgHeader = {
        authToken: localStorage.getItem("authtoken"), //dynamic
        authLoginID: this.$store.getters.loginId,
        timestamp: timestamp,
        ipAddress: userip
      };
      var employeeKycDetails = { data, msgHeader };
      axios
        .post("mlGetUploadInvoiceStatus", employeeKycDetails)
        .then(response => {
          const JSONData = response.data;
          if (JSONData.data.error == 0) {
            var setTempInvoice = JSONData.data.invoiceDetails;
            for (var i = 0; i < setTempInvoice.length; i++) {
              if (setTempInvoice[i].status === true) {
                this.invoiceDetails.push(setTempInvoice[i]);
              }
            }
            // this.invoiceDetails = JSONData.data.invoiceDetails

            console.log("this is the data for invoice", this.invoiceDetails);
          } else {
            this.errorText = JSONData.data.message;
            if (
              this.errorText === "Invalid login" ||
              this.errorText === "sessionTimeout" ||
              this.errorText === "Invalid credentials"
            ) {
              this.genralErrorFlag = true;
            } else {
              this.errorText = JSONData.data.message;
              this.errorFlag = true;
            }
          }
          this.$store.commit("routeChange", "end");
        })
        .catch(error => {
          this.errorText = "Network Error";
          console.log("display Error" + this.errorText);
          this.$store.commit("routeChange", "end");
        });
    }
  },
  computed: {
    items() {
      console.log();
      if (
        this.invoiceNumber.length == 0 &&
        this.supplierName.length == 0 &&
        this.merchantName.length == 0 &&
        this.rangeDate.length == 0
      ) {
        this.totalRows = this.invoiceDetails.length;
        return this.invoiceDetails;
      } else {
        var list = this.invoiceDetails;
        console.log(
          "this is the invoice list",
          JSON.stringify(this.invoiceDetails)
        );
        if (this.supplierName.length > 0) {
          list = list.filter(invoice =>
            invoice.supplierDetails.name
              .toLowerCase()
              .includes(this.supplierName.toLowerCase())
          );
        }
        if (this.invoiceNumber.length > 0) {
          list = list.filter(invoice =>
            invoice.purchaseOrderNumber
              .toLowerCase()
              .includes(this.invoiceNumber.toLowerCase())
          );
        }
        if (this.merchantName.length > 0) {
          list = list.filter(invoice =>
            invoice.borrowerName
              .toLowerCase()
              .includes(this.merchantName.toLowerCase())
          );
        }
        if (this.rangeDate.length > 0 && this.rangeDate.includes("to")) {
          list = list.filter(
            invoice =>
              Date.parse(invoice.createdAt) >
              Date.parse(this.rangeDate.split("to")[0]) &&
              Date.parse(invoice.createdAt) <
              Date.parse(this.rangeDate.split("to")[1])
          );
        }
        this.totalRows = list.length;
        return list;
      }
    },

    bulkitems() {
      console.log();
      if (
        this.invoiceNumberB.length == 0 &&
        this.supplierNameB.length == 0 &&
        this.merchantNameB.length == 0 &&
        this.rangeDateB.length == 0
      ) {
        this.totalRows = this.invoiceDetails.length;
        return this.invoiceDetails;
      } else {
        var list = this.invoiceDetails;

        var newarry = list.map(function (item) {
          if (item.supplierName === null) {
            item.supplierName = "";
          }
          if (item.purchaseOrderNumber === null) {
            item.purchaseOrderNumber = "";
          }

          if (item.borrowerName === null) {
            item.borrowerName = "";
          }

          return item;
        });
        console.log("this is th complete List", JSON.stringify(newarry));
        if (this.supplierNameB.length > 0) {
          list = list.filter(invoice =>
            invoice.supplierName
              .toLowerCase()
              .includes(this.supplierNameB.toLowerCase())
          );
        }
        if (this.invoiceNumberB.length > 0) {
          list = list.filter(invoice =>
            invoice.purchaseOrderNumber
              .toLowerCase()
              .includes(this.invoiceNumberB.toLowerCase())
          );
        }
        if (this.merchantNameB.length > 0) {
          list = list.filter(invoice =>
            invoice.borrowerName
              .toLowerCase()
              .includes(this.merchantNameB.toLowerCase())
          );
        }

        if (this.rangeDateB.length > 0 && this.rangeDateB.includes("to")) {
          list = list.filter(
            invoice =>
              Date.parse(invoice.invoiceDate) >
              Date.parse(this.rangeDateB.split("to")[0]) &&
              Date.parse(invoice.invoiceDate) <
              Date.parse(this.rangeDateB.split("to")[1])
          );
        }
        this.totalRows = list.length;
        return list;
      }
    }
  },
  watch: {
    // $route() {
    //   this.Stages();
    // },

    companyName() {
      console.log("hi");
      if (this.companyName != "") {
        this.statusSend = "Submitted";
        this.activeTab = 1;
        this.getInvoices();
      }
    }
  }
};
</script>
<style lang="scss">
@import "../../../src/@core/scss/vue/libs/vue-flatpicker.scss";
</style>
<style lang="scss">
/*! rtl:begin:ignore */
#dashboard-analytics {
  .card {
    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
    transition: 0.3s;
    width: 20%;
    margin: 10px;
    margin: 5px;
    height: 92px;
  }

  .h4 {
    font-family: Montserrat;
    font-style: normal;
    font-weight: 600;
    font-size: 21px;
    line-height: 26px;
    color: #b9b9c3;
  }

  .card:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
  }

  .card:focus {
    background-color: red;
  }

  .card:active {
    background-color: var(--lgtr-blue);
  }

  .container {
    padding: 2px 16px;
  }

  .changecolor {
    border-color: rgba(70, 50, 109, 1) !important;
    background-color: #ff9f43 !important;
    color: #ffffff;
  }

  .changecolorOne {
    border-color: rgba(70, 50, 109, 1) !important;
    background-color: #97c93e !important;
    color: #ffffff;
  }

  .changecolorTwo {
    border-color: rgba(70, 50, 109, 1) !important;
    background-color: #4328ae !important;
    color: #ffffff;
  }

  .changecolorThree {
    border-color: rgba(70, 50, 109, 1) !important;
    background-color: #00cfe8 !important;
    color: #ffffff;
  }

  .changecolorFour {
    border-color: rgba(70, 50, 109, 1) !important;
    background-color: #ea5455 !important;
    color: #ffffff;
  }

  .testimonial-group>.row {
    overflow-x: auto;
    white-space: nowrap;
  }

  .testimonial-group>.row>.card {
    display: inline-block;
    float: none;
  }

  .nameHeader {
    font-family: Montserrat;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 15px;
    /* identical to box height */

    /* 1) Theme Color / Muted & Placeholder - Text */

    color: #b9b9c3;
  }

  .greet-user {
    position: relative;

    .decore-left {
      position: absolute;
      left: 0;
      top: 0;
    }

    .decore-right {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  @media (max-width: 576px) {

    .decore-left,
    .decore-right {
      width: 140px;
    }
  }

  .vs-con-table {
    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap-reverse;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      >span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          &+i {
            left: 1rem;
          }

          &:focus+i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.05);
        padding: 10px;

        td {
          padding: 10px;
          font-family: Montserrat;
          font-style: normal;
          font-weight: normal;
          font-size: 12px;
          line-height: 15px;

          /* identical to box height */

          /* 1) Theme Color / Heading & Display - Text */

          color: #5e5873;

          &:first-child {
            border-top-left-radius: 0.5rem;
            border-bottom-left-radius: 0.5rem;
          }

          &:last-child {
            border-top-right-radius: 0.5rem;
            border-bottom-right-radius: 0.5rem;
          }

          &.img-container {
            // width: 1rem;
            // background: #fff;

            span {
              display: flex;
              justify-content: flex-start;
            }

            .product-img {
              height: 110px;
            }
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}

/*! rtl:end:ignore */
</style>
